import {
  type ColumnDef,
  getCoreRowModel,
  getPaginationRowModel,
  useReactTable,
} from "@tanstack/react-table";

import { Skeleton } from "@/components/ui/skeleton";
import { VirtualizedTable } from "@/components/ui/virtualized-table";
import { memo, useState } from "react";

const SkeletonCell = memo(function SkeletonCell() {
  return <Skeleton className="h-[20px] my-[12px] mx-[4px]" />;
});

type Props = {
  columnVisibility?: Record<string, boolean>;
  columns: ColumnDef<any>[];
  ignoreColumns?: Record<string, boolean>;
  tableContainerRef: React.RefObject<HTMLDivElement>;
  hideHeader?: boolean;
};

export const SkeletonTable = ({
  columns: _columns,
  columnVisibility,
  ignoreColumns = {},
  tableContainerRef,
  hideHeader = false,
}: Props) => {
  const [data] = useState(Array(50).fill({}));

  const [columns] = useState(
    _columns.map((column) => {
      return {
        ...column,
        cell: () => {
          if (column.id && ignoreColumns[column.id]) {
            return null;
          }
          return <SkeletonCell />;
        },
      };
    }),
  );

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    manualPagination: true,
    initialState: {
      columnVisibility,
    },
    defaultColumn: {
      size: undefined,
    },
  });

  return (
    <VirtualizedTable
      table={table}
      loading={true}
      tableContainerRef={tableContainerRef}
      hideHeader={hideHeader}
    />
  );
};
